import React from 'react';
import Loading from 'react-loading';
import { theme } from '@weave/theme-original';
import { css } from 'emotion';

type LoaderProps = { width?: string; height?: string };

export const Loader: React.FC<LoaderProps> = ({ width, height }) => {
  return (
    <Loading
      color={theme.colors.weaveBlue}
      type="spin"
      width={width ?? theme.spacing(1.5)}
      height={height ?? theme.spacing(1.5)}
      className={css`
        display: inline-block;
        margin: 0 ${theme.spacing(0.5)};
      `}
    />
  );
};
